/* hod-promo.js — HOD Canada port (2026-10-06) of the countdown from the US assets/hod-home.js (flash banner + sale banner). Vanilla, no deps; runs once. */
(function () {
  'use strict';
  if (window.__hodPromoInit) return;
  window.__hodPromoInit = true;
  var INIT = new WeakSet();
  /* ---------------- COUNTDOWN ---------------- */
  function initCountdown(box) {
    if (INIT.has(box)) return;
    INIT.add(box);
    /* data-end is either an epoch in seconds (Liquid `date: '%s'`, store time — every visitor sees the same end)
       or a date string (older sections); the string form is parsed in the visitor's zone */
    var raw = (box.getAttribute('data-end') || '').trim();
    var end = /^\d{9,}$/.test(raw) ? Number(raw) * 1000 : new Date(raw).getTime();
    if (isNaN(end)) { box.hidden = true; return; }
    var cells = {
      d: box.querySelectorAll('[data-cd="d"] b'), h: box.querySelectorAll('[data-cd="h"] b'),
      m: box.querySelectorAll('[data-cd="m"] b'), s: box.querySelectorAll('[data-cd="s"] b')
    };
    function p2(n) { return String(n).padStart(2, '0'); }
    function set(pair, val) { if (pair.length === 2) { pair[0].textContent = val[0]; pair[1].textContent = val[1]; } }
    /* Stas 9/6: when the countdown reaches zero the whole flash block disappears (section wrapper) */
    var section = box.closest('.shopify-section') || box.closest('.hod-hp__wrap') || box;
    /* 10/1: a box with data-cd-keep (sale banner) hides only itself at zero — the banner stays up */
    var target = box.hasAttribute('data-cd-keep') ? box : section;
    var iv = null;
    function tick() {
      if (!box.isConnected) { clearInterval(iv); return; }   /* the editor re-rendered the section; the new box gets its own init */
      var diff = Math.max(0, end - Date.now());
      if (diff <= 0) { if (!(window.Shopify && window.Shopify.designMode)) target.hidden = true; clearInterval(iv); return; }
      set(cells.d, p2(Math.min(99, Math.floor(diff / 864e5))));
      set(cells.h, p2(Math.floor(diff / 36e5) % 24));
      set(cells.m, p2(Math.floor(diff / 6e4) % 60));
      set(cells.s, p2(Math.floor(diff / 1e3) % 60));
    }
    tick(); iv = setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-hp-countdown]').forEach(initCountdown);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-hp-countdown]').forEach(initCountdown); });
  }
})();
